import React, { useState, Fragment, useEffect } from 'react';
import {
    Row,
    Input,
    Label,
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Card,
    CardBody,
    CardHeader,
    CardFooter
} from 'reactstrap';
import { reactSelectOptionDiffrentPro } from '../../../../../../helpers/Utils';
import Select from 'react-select';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import Triggers from '../../../../../../data/Triggers';
import country from '../../../../../../data/country';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { useSelector } from "react-redux";
import {
    postAPI_Create_OutboundTrigger,
    putAPI_Update_OutboundTrigger,
    gAPI_OutboundTrigger_By_Id
} from '../../../../../../constants/APIs';
import Validation from '../../../../../../components/Validation';
import IntlMessages from '../../../../../../helpers/IntlMessages';
export function TriggerForm({ visible, formLabel, toggle, triggerId, propertyId, LoadData }) {

    const { timeZone } = useSelector(({ settings }) => ({
        timeZone: settings.timeZone,
    }));
    const [inputData, setInputData] = useState({
        triggerName: "",
        trigger: [{
            text: "",
            operator: "",
            country: [{ name: "", code: "" }],
            tags: [],
            daysMinutes: { text: "", type: "" },
            stayLength: "",
        }],
        scheduleTime: null,
    });
    const [open, setOpen] = useState(false);
    const [msg, setMsg] = useState([]);
    const [triggerList1, setTriggerList1] = useState([]);
    const [triggerList2, setTriggerList2] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState([]);
    const hasConditions = inputData.trigger.length > 1;

    const TIME_OPTIONS = Array.from({ length: 24 }, (_, idx) => `${idx.toString().padStart(2, '0')}:00`);
    useEffect(() => {
        const list1 = Triggers.filter((k) => k.value !== "guest_country" && k.value !== "guest_length_stay");
        setTriggerList1(list1);
        const list2 = Triggers.filter((k) => k.value === "guest_country" || k.value === "guest_length_stay");
        setTriggerList2(list2);
        if (triggerId !== undefined) {
            AxiosAPI({
                methhod: 'get',
                url: `${gAPI_OutboundTrigger_By_Id}/${triggerId}?TimeZone=${timeZone}`,
            }).then((res) => {
                const apiData = res.data;
                // If backend sends full datetime → extract only HH:mm
                if (apiData.scheduleTime) {
                    apiData.scheduleTime = apiData.scheduleTime.slice(11, 16);
                }
                setInputData(apiData);
                apiData.trigger.map((item) => {
                    if (item.country && item.country.length > 0) {
                        if (item.text === "guest_country") {
                            var con = [];
                            item.country.map(i =>
                                country.filter((e) => e.code === i.code).map(items =>
                                    con.push({
                                        value: items.code,
                                        label: items.name
                                    })
                                ))
                            setSelectedCountry(con);
                        }
                    }
                });
            }).catch((err) => console.log('err', err));
        }
    }, [triggerId]);
    const handleInputData = (e, subIndex) => {
        const values = { ...inputData };
        if (e.target.name === "trigger") {
            values.trigger[subIndex].text = e.target.value;
            if (e.target.value === "guest_upcoming_booking") {
                values.trigger[subIndex].daysMinutes.text = "0";
                values.trigger[subIndex].daysMinutes.type = "Days";

                values.scheduleTime = null;
            } else if (e.target.value === "guest_checked_in") {
                values.trigger[subIndex].daysMinutes.type = "Minutes";
                values.trigger[subIndex].daysMinutes.text = "0";

                values.scheduleTime = null;
            } else {
                values.trigger[subIndex].daysMinutes.type = "0";
                values.trigger[subIndex].daysMinutes.text = "0";

                values.scheduleTime = null;
            }
            values.trigger[subIndex].tags = [];
            values.trigger[subIndex].country = [];
        }
        else if (e.target.name === "operator") {
            values.trigger[subIndex].operator = e.target.value;
        }
        else if (e.target.name === "stayLength") {
            values.trigger[subIndex].stayLength = e.target.value;
            values.trigger[subIndex].tags = [];
            values.trigger[subIndex].country = [];
        }
        else if (e.target.name === "name") {
            values.triggerName = e.target.value;
        }
        setInputData(values);
    };
    const handleScheduleTimeChange = (e) => {
        const value = e.target.value;

        setInputData(prev => ({
            ...prev,
            scheduleTime: value === "" ? null : value
        }));
    };

    const showScheduleTime =
        inputData.trigger.some(t =>
            t.text === "guest_upcoming_booking" ||
            (t.text === "guest_checked_out" && t.daysMinutes?.type === "Days")
        );

    const handleRemoveTrigger = (subIndex) => {
        const values = { ...inputData };
        values.trigger.splice(subIndex, 1);
        setInputData(values);
    };
    const handleMoreTrigger = (e) => {
        const values = { ...inputData };
        values.trigger.push({
            text: "",
            operator: "AND",
            tags: [],
            daysMinutes: { text: "", type: "" },
            stayLength: "",
        });
        setInputData(values);
    };
    const handleDayAndMinutes = (e, subIndex) => {
        const values = { ...inputData };
        console.log(values);
        if (e.target.name === "text") {
            values.trigger[subIndex].daysMinutes.text = e.target.value;
            values.trigger[subIndex].tags = [];
            values.trigger[subIndex].country = [];
        }
        else if (e.target.name === "type") {
            values.trigger[subIndex].daysMinutes.type = e.target.value;
            values.trigger[subIndex].tags = [];
            values.trigger[subIndex].country = [];
        }

        if (values.trigger[subIndex].text === "guest_checked_out" && e.target.value === "Minutes") {
            values.scheduleTime = null;
        }

        setInputData(values);
    };

    const handleSubmit = () => {
        if (showScheduleTime && !inputData.scheduleTime) {
            setMsg(["Time is mandatory when Days is selected"]);
            setOpen(true);
            return;
        }
        if (triggerId === undefined) {
            let body = {
                ...inputData,
                groupId: getGroupID(),
                timeZone,
                propertyId: propertyId,
                status: "Active",
                creator: 'dashboard',
            }

            AxiosAPI({
                method: 'post',
                url: `${postAPI_Create_OutboundTrigger}`,
                data: body,
            }).then((res) => {
                if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                    && res.data.Messages !== null && res.data.Messages.length > 0) {
                    setMsg(res.data.Messages);
                    setOpen(true);
                }
                else {
                    setToggle();
                    LoadData();
                }
            }).catch((err) => {
                console.log('err', err);
            });
        }
        else {
            let updateBody = {
                ...inputData,
                timeZone,
                groupId: getGroupID(),
                propertyId: propertyId,
                updater: "dashboard"
            }
            AxiosAPI({
                method: 'put',
                url: `${putAPI_Update_OutboundTrigger}/${triggerId}`,
                data: updateBody,
            }).then((res) => {
                if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
                    && res.data.Messages !== null && res.data.Messages.length > 0) {
                    setMsg(res.data.Messages);
                    setOpen(true);
                }
                else {
                    setToggle();
                    LoadData();
                }
            }).catch((err) => {
                console.log('err', err);
            });
        }
    };
    const setToggle = () => {
        setInputData({
            triggerName: "",
            trigger: [{
                text: "",
                operator: "",
                tags: [],
                daysMinutes: { text: "", type: "" },
            }],
            creator: 'dashboard',
        });
        toggle(!visible);
    }
    const handleChangeSelect = (selectedOptions, subIndex, name) => {
        let tags = [];
        if (name === "country") {
            setSelectedCountry(selectedOptions.value);
            tags = selectedOptions.map((a) =>
            ({
                name: a.label,
                code: a.value
            }));
        }
        const values = { ...inputData };
        values.trigger[subIndex].country = tags;
        values.trigger[subIndex].tags = [];
        setInputData(values);
    };
    return (
        <Fragment>
            <Modal isOpen={visible} toggle={toggle} size="lg">
                <ModalHeader toggle={toggle}>
                    {formLabel} a Trigger <br />
                    <span className="text-muted text-small d-block">
                        <IntlMessages id='dashboard.outbound_msg' />
                    </span>
                </ModalHeader>
                <ModalBody>
                    <Row className="mb-4">
                        <Colxx xxs="12">
                            {inputData && (
                                <Card style={{ marginBottom: "10px" }}>
                                    <CardBody>
                                        <Row>
                                            <Colxx sm={12} className="mb-6" style={{ marginBottom: "10px" }}>
                                                <Input
                                                    type="text"
                                                    value={inputData.triggerName}
                                                    placeholder="Trigger Name"
                                                    onChange={(e) => handleInputData(e)}
                                                    name="name"
                                                />
                                            </Colxx>
                                        </Row>
                                        <Row>
                                            {inputData.trigger.map((con, itemIndex) => (
                                                <Fragment key={itemIndex}>
                                                    {itemIndex !== 0 && (
                                                        <Colxx sm={3} lg={4} className="mb-6" style={{ marginBottom: "10px" }}>
                                                            <Input
                                                                type="select"
                                                                value={con.operator}
                                                                name="operator"
                                                                onChange={(e) => handleInputData(e, itemIndex)}>
                                                                <option value="AND">AND</option>
                                                            </Input>
                                                        </Colxx>
                                                    )}
                                                    <Colxx
                                                        sm={itemIndex === 0 ? 12 : con.tags && con.tags.length === 0 ? 7 : 8}
                                                        className="mb-6"
                                                        style={{ marginBottom: "10px" }}>
                                                        <Input
                                                            type="select"
                                                            value={con.text}
                                                            name="trigger"
                                                            onChange={(e) => handleInputData(e, itemIndex)}
                                                        >
                                                            <option value={0}>Select Trigger</option>
                                                            {itemIndex === 0 ?
                                                                triggerList1.map((elem, i) => {
                                                                    return (
                                                                        <option key={i} value={elem.value}>
                                                                            {elem.label}
                                                                        </option>
                                                                    );
                                                                }) :
                                                                triggerList2.map((elem, i) => {
                                                                    return (
                                                                        <option key={i} value={elem.value}>
                                                                            {elem.label}
                                                                        </option>
                                                                    );
                                                                })}
                                                        </Input>
                                                    </Colxx>
                                                    {con.text !== "0" && con.text !== "" && con.text !== "guest_country" && con.text !== "guest_length_stay" && (
                                                        <Colxx sm={12} className="mb-6" style={{ marginBottom: "10px" }}>
                                                            <Row>
                                                                <Colxx sm={2}>
                                                                    <p style={{
                                                                        width: "100px",
                                                                        marginTop: "6px",
                                                                        marginLeft: "3px"
                                                                    }}>Send a message</p>
                                                                </Colxx>
                                                                <Colxx sm={2}>
                                                                    <Input
                                                                        type="number"
                                                                        value={con.daysMinutes.text}
                                                                        name="text"
                                                                        onChange={(e) => handleDayAndMinutes(e, itemIndex)}
                                                                    />
                                                                </Colxx>
                                                                {con.text === "guest_checked_out" && (
                                                                    <Colxx sm={2}>
                                                                        <Input
                                                                            type="select"
                                                                            value={con.daysMinutes.type}
                                                                            name="type"
                                                                            onChange={(e) => handleDayAndMinutes(e, itemIndex)}
                                                                        >
                                                                            <option value="0">Select</option>
                                                                            <option value="Days">Days</option>
                                                                            <option value="Minutes">Minutes</option>
                                                                        </Input>
                                                                    </Colxx>
                                                                )}
                                                                <Colxx sm={6}>
                                                                    <p style={{
                                                                        marginTop: "6px",
                                                                        marginLeft: "-6px"
                                                                    }}>
                                                                        {con.text === "guest_upcoming_booking" && "days before check-in"}
                                                                        {con.text === "guest_checked_in" && "minutes after check-in"}
                                                                        {con.text === "guest_checked_out" && "after check-out"}
                                                                    </p>
                                                                </Colxx>
                                                            </Row>
                                                        </Colxx>
                                                    )}
                                                    {con.text === "guest_country" && (
                                                        <Colxx sm={itemIndex === 0 ? 12 : 11} className="mb-6" style={{ marginBottom: "10px" }}>
                                                            <Select
                                                                isMulti={true}
                                                                className="react-select"
                                                                classNamePrefix="react-select"
                                                                name="country"
                                                                placeholder="Countries"
                                                                onChange={(e) => handleChangeSelect(e, itemIndex, "country")}
                                                                options={
                                                                    country
                                                                        ? reactSelectOptionDiffrentPro(
                                                                            country,
                                                                            true,
                                                                            'code',
                                                                            'name',
                                                                            'All Countries'
                                                                        )
                                                                        : []
                                                                }
                                                                value={selectedCountry}
                                                            />
                                                        </Colxx>
                                                    )}
                                                    {con.text === "guest_length_stay" && (
                                                        <Colxx sm={itemIndex === 0 ? 12 : 11} className="mb-6" style={{ marginBottom: "10px" }}>
                                                            <Input
                                                                type="text"
                                                                value={con.stayLength}
                                                                onChange={(e) => handleInputData(e, itemIndex)}
                                                                name="stayLength"
                                                            />
                                                        </Colxx>
                                                    )}
                                                    {itemIndex !== 0 && (
                                                        <Fragment>
                                                            <Colxx sm={1} className="mb-6">
                                                                <Button
                                                                    onClick={() =>
                                                                        handleRemoveTrigger(itemIndex)
                                                                    }
                                                                    color="secondary"
                                                                    size="xs"
                                                                    outline
                                                                    style={{ margin: '6px' }}
                                                                >
                                                                    -
                                                                </Button>
                                                            </Colxx>
                                                        </Fragment>
                                                    )}
                                                </Fragment>
                                            ))}
                                            {inputData.trigger.length < 3 && (
                                                <Colxx sm={6} className="mb-6">
                                                    <Button
                                                        onClick={(e) => handleMoreTrigger(e)}
                                                        color="secondary"
                                                        size="sm"
                                                        outline
                                                        style={{ margin: '6px' }}
                                                    >
                                                        + Condition
                                                    </Button>
                                                </Colxx>
                                            )}

                                            {showScheduleTime && hasConditions && (
                                                <Colxx sm={12} style={{ marginBottom: "10px" }}>
                                                    <div style={{ display: "flex", alignItems: "center", gap: "80px" }}>
                                                        {/* Timezone TEXT (not dropdown) */}
                                                        <span style={{ fontWeight: 500 }}>
                                                            <b>TimeZone:</b> {timeZone}
                                                        </span>

                                                        {/* Time dropdown */}
                                                        <Input
                                                            type="select"
                                                            style={{ width: 110 }}
                                                            value={inputData.scheduleTime ?? ""}
                                                            name="scheduleTime"
                                                            onChange={handleScheduleTimeChange}

                                                        >
                                                            <option value="">Time</option>
                                                            {TIME_OPTIONS.map(t => (
                                                                <option key={t} value={t}>{t}</option>
                                                            ))}
                                                        </Input>

                                                    </div>
                                                </Colxx>
                                            )}
                                            {showScheduleTime && !hasConditions && (
                                                <Colxx sm={6} style={{ display: "flex", justifyContent: "flex-end" }}>
                                                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                        <span><b>TimeZone:</b> {timeZone}</span>

                                                        <Input
                                                            type="select"
                                                            style={{ width: 110 }}
                                                            value={inputData.scheduleTime ?? ""}
                                                            name="scheduleTime"
                                                            onChange={handleScheduleTimeChange}
                                                        >
                                                            <option value="">Time</option>
                                                            {TIME_OPTIONS.map(t => (
                                                                <option key={t} value={t}>{t}</option>
                                                            ))}
                                                        </Input>
                                                    </div>
                                                </Colxx>
                                            )}
                                        </Row>
                                    </CardBody>
                                </Card>
                            )}
                        </Colxx>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button color="primary"
                        onClick={handleSubmit}
                    >
                        {formLabel}
                    </Button>
                    <Button color="secondary" onClick={toggle}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
            <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
        </Fragment>
    );
}